jQuery(document).ready(function($) {
    let activeModal = null;
    let originalModalContent = null;
    let dismissedByButton = false;
    
    // Remove modify preferences link if in page subscribe button exists to avoid confusion.
    if ($('#subscribe-in-page-button').length) {
        $("a[href='#unsubscribe']").parent().remove();
    }

    // Function to set a cookie
    function setCookie(name, value, days) {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
    }

    // Function to get a cookie
    function getCookie(name) {
        const nameEQ = name + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return null;
    }

    function openSubscribeModal() {
        if (activeModal || !$('#subscribe-page-modal').length || $('#subscribe-in-page-button').length) {
            return;
        }

        originalModalContent = $('#subscribe-page-modal').clone();
        dismissedByButton = false; // Reset when opening

        activeModal = new jBox('Modal', {
            content: $('#subscribe-page-modal'),
            height: 'auto', // Auto height to fit content
            width: '500',
            addClass: 'mailing-list-modal',
            closeOnClick: false, // Prevent backdrop click from closing the modal
            onClose: function() {
                activeModal = null;
                $('#subscribe-page-modal').replaceWith(originalModalContent);
            },
            onCloseComplete: function() {
                if (dismissedByButton) {
                    // Set a cookie to hide the modal for 14 days
                    setCookie('kristi_mailing_list_modal_dismissed', 'true', 14);
                } else {
                    // It was closed by clicking the 'x' button.
                    // Recur after 2 minutes
                    const recurDelay = 120000;
                    sessionStorage.setItem('kristi_mailing_list_next_show', Date.now() + recurDelay);
                    setTimeout(openSubscribeModal, recurDelay);
                }
            }
        }).open();
    }

    // Check if the modal has been dismissed permanently, and if the shortcode exists on the page
    if (getCookie('kristi_mailing_list_modal_dismissed') !== 'true') {
        const checkAndScheduleModal = function() {
            let nextShow = sessionStorage.getItem('kristi_mailing_list_next_show');
            if (!nextShow) {
                // Not set yet (first visit in this session). Set it to 2 minutes from now.
                nextShow = Date.now() + 120000;
                sessionStorage.setItem('kristi_mailing_list_next_show', nextShow);
            } else {
                nextShow = parseInt(nextShow, 10);
            }

            const now = Date.now();
            if (now >= nextShow) {
                openSubscribeModal();
            } else {
                setTimeout(openSubscribeModal, nextShow - now);
            }
        };

        checkAndScheduleModal();
    }

    // Handle manual subscribe button click
    $(document).on('click', '.subscribe-button', function(e) {
        e.preventDefault();
        openSubscribeModal();
    });

    // Handle subscribe button click
    $(document).on('click', '#subscribe-button, #subscribe-in-page-button', function(e) {
        e.preventDefault();
        const firstName = $('#subscriber_first_name').val();
        const lastName = $('#subscriber_last_name').val();
        const email = $('#subscriber_email').val();
        let validationEl = $('#subscribe-page-modal #validation');
        if(!validationEl.length) {
            validationEl = $('#in-page-subscribe-form #validation'); // Fallback to in-page validation element
        }
        const attributes = {};

        validationEl.text('');

        // Basic validation
        if (!email) {
            validationEl.text('Email address is required.');
            return;
        }

        const isModal = $(this).attr('id') === 'subscribe-button';
        const formContainer = isModal ? $('#subscribe-page-modal') : $('#in-page-subscribe-form');
        
        let interestsExist = formContainer.find('input[name^="brevo_attributes[INTERESTS]"]').length > 0;
        let preferencesExist = formContainer.find('input[name^="brevo_attributes[PREFERENCES]"]').length > 0;

        let hasInterests = formContainer.find('input[name^="brevo_attributes[INTERESTS]"]:checked').length > 0;
        let hasPreferences = formContainer.find('input[name^="brevo_attributes[PREFERENCES]"]:checked').length > 0;

        if ( (interestsExist && !hasInterests) || (preferencesExist && !hasPreferences) ) {
            validationEl.text('Please select at least one Interest and at least one Preference.');
            return;
        }

        // Get attributes
		formContainer.find('input[name^="brevo_attributes"]:checked').each(function() {
			const name = $(this).attr('name');
			const value = $(this).val();
			const attributeName = name.substring(name.indexOf('[') + 1, name.indexOf(']'));

			if (!attributes[attributeName]) {
				attributes[attributeName] = [];
			}
			attributes[attributeName].push(value);
		});


        $.ajax({
            url: KGLASS_MODAL.ajax_url,
            type: 'POST',
            data: {
                action: 'klg_subscribe_user',
                nonce: KGLASS_MODAL.nonce,
                first_name: firstName,
                last_name: lastName,
                email: email,
				attributes: attributes
            },
            success: function(response) {
                if(response.success) {
                    if (activeModal) {
                        dismissedByButton = true;
                        activeModal.close();
                    }
                    new jBox('Notice', {
                        content: response.data.message,
                        color: 'green',
                        autoClose: 5000
                    });
                } else {
                    validationEl.text(response.data.message);
                }
            },
            error: function() {
                validationEl.text('An error occurred. Please try again.');
            }
        });
    });

    // Handle unsubscribe button click
    $(document).on('click', '#confirm-choice', function(e) {
        e.preventDefault();
        const email = $('#unsubscriber_email').val();
        const validationEl = $('#unsubscribe-page-modal #unvalidation');

        validationEl.text('');

        if (!email) {
            validationEl.text('Email address is required.');
            return;
        }

        $.ajax({
            url: KGLASS_MODAL.ajax_url,
            type: 'POST',
            data: {
                action: 'klg_unsubscribe_user',
                nonce: KGLASS_MODAL.nonce,
                email: email
            },
            success: function(response) {
                if(response.success) {
                    if (activeModal) {
                        activeModal.close();
                    }
                    new jBox('Notice', {
                        content: response.data.message,
                        color: 'green',
                        autoClose: 5000
                    });
                } else {
                    validationEl.text(response.data.message);
                }
            },
            error: function() {
                validationEl.text('An error occurred. Please try again.');
            }
        });
    });

    // Refresh the in-page math captcha question and transient ID
    function refreshInPageMathCaptcha() {
        const captchaGroup = $('.in-page-unsubscribe-form-container .math-captcha-group');
        if (!captchaGroup.length) return;

        $.ajax({
            url: KGLASS_MODAL.ajax_url,
            type: 'POST',
            data: {
                action: 'klg_refresh_math_captcha',
                nonce: KGLASS_MODAL.nonce
            },
            success: function(response) {
                if (response.success) {
                    captchaGroup.find('label').html(response.data.question + ' <span class="required" style="color:red;">*</span>');
                    captchaGroup.find('input[type="hidden"]').val(response.data.transient_id);
                    captchaGroup.find('input[type="number"]').val('');
                }
            }
        });
    }

    // Handle in-page unsubscribe button click
    $(document).on('click', '#unsubscribe-in-page-submit-btn', function(e) {
        e.preventDefault();
        const email = $('#unsubscribe_in_page_email').val();
        const validationEl = $('#unsubscribe-in-page-validation');
        const hp = $('#unsubscribe_in_page_hp').val();
        const mathAnswer = $('#unsubscribe_in_page_math_answer').val();
        const mathTransientId = $('#unsubscribe_in_page_math_transient_id').val();

        validationEl.css('color', 'red').text('');

        if (!email) {
            validationEl.text('Email address is required.');
            return;
        }

        const isMathExist = $('#unsubscribe_in_page_math_answer').length > 0;
        if (isMathExist && !mathAnswer) {
            validationEl.text('Please solve the math problem.');
            return;
        }

        $.ajax({
            url: KGLASS_MODAL.ajax_url,
            type: 'POST',
            data: {
                action: 'klg_in_page_unsubscribe',
                nonce: KGLASS_MODAL.nonce,
                email: email,
                hp_field_verify: hp,
                math_answer: mathAnswer,
                math_transient_id: mathTransientId
            },
            success: function(response) {
                if (response.success) {
                    validationEl.css('color', 'green').text(response.data.message);
                    $('#unsubscribe_in_page_email').val('');
                    $('#in-page-unsubscribe-form-container').find('input[type="checkbox"]').prop('checked', false);
                    refreshInPageMathCaptcha();
                } else {
                    validationEl.css('color', 'red').text(response.data.message);
                    refreshInPageMathCaptcha();
                }
            },
            error: function() {
                validationEl.css('color', 'red').text('An error occurred. Please try again.');
                refreshInPageMathCaptcha();
            }
        });
    });

    // Handle in-page change preferences button click
    $(document).on('click', '#unsubscribe-in-page-preferences-btn', function(e) {
        e.preventDefault();
        const email = $('#unsubscribe_in_page_email').val();
        const validationEl = $('#unsubscribe-in-page-validation');
        const hp = $('#unsubscribe_in_page_hp').val();
        const mathAnswer = $('#unsubscribe_in_page_math_answer').val();
        const mathTransientId = $('#unsubscribe_in_page_math_transient_id').val();
        const attributes = {};

        validationEl.css('color', 'red').text('');

        // Basic validation
        if (!email) {
            validationEl.text('Email address is required.');
            return;
        }

        const isMathExist = $('#unsubscribe_in_page_math_answer').length > 0;
        if (isMathExist && !mathAnswer) {
            validationEl.text('Please solve the math problem.');
            return;
        }

        const formContainer = $('#in-page-unsubscribe-form-container');
        
        let interestsExist = formContainer.find('input[name^="brevo_attributes[INTERESTS]"]').length > 0;
        let preferencesExist = formContainer.find('input[name^="brevo_attributes[PREFERENCES]"]').length > 0;

        let hasInterests = formContainer.find('input[name^="brevo_attributes[INTERESTS]"]:checked').length > 0;
        let hasPreferences = formContainer.find('input[name^="brevo_attributes[PREFERENCES]"]:checked').length > 0;

        if ( (interestsExist && !hasInterests) || (preferencesExist && !hasPreferences) ) {
            validationEl.text('Please select at least one Interest and at least one Preference.');
            return;
        }

        // Get attributes from the in-page form checkboxes
        formContainer.find('input[name^="brevo_attributes"]:checked').each(function() {
            const name = $(this).attr('name');
            const value = $(this).val();
            const attributeName = name.substring(name.indexOf('[') + 1, name.indexOf(']'));

            if (!attributes[attributeName]) {
                attributes[attributeName] = [];
            }
            attributes[attributeName].push(value);
        });

        $.ajax({
            url: KGLASS_MODAL.ajax_url,
            type: 'POST',
            data: {
                action: 'klg_in_page_change_preferences',
                nonce: KGLASS_MODAL.nonce,
                email: email,
                attributes: attributes,
                hp_field_verify: hp,
                math_answer: mathAnswer,
                math_transient_id: mathTransientId
            },
            success: function(response) {
                if (response.success) {
                    validationEl.css('color', 'green').text(response.data.message);
                    $('#unsubscribe_in_page_math_answer').val('');
                    refreshInPageMathCaptcha();
                } else {
                    validationEl.css('color', 'red').text(response.data.message);
                    refreshInPageMathCaptcha();
                }
            },
            error: function() {
                validationEl.css('color', 'red').text('An error occurred. Please try again.');
                refreshInPageMathCaptcha();
            }
        });
    });

    // Handle change preferences button click
    $(document).on('click', '#change-preferences', function(e) {
        e.preventDefault();
        const email = $('#unsubscriber_email').val();
        const validationEl = $('#unsubscribe-page-modal #unvalidation');
        const attributes = {};

        validationEl.text('');

        // Basic validation
        if (!email) {
            validationEl.text('Email address is required.');
            return;
        }

        const formContainer = $('#unsubscribe-page-modal');
        
        let interestsExist = formContainer.find('input[name^="brevo_attributes[INTERESTS]"]').length > 0;
        let preferencesExist = formContainer.find('input[name^="brevo_attributes[PREFERENCES]"]').length > 0;

        let hasInterests = formContainer.find('input[name^="brevo_attributes[INTERESTS]"]:checked').length > 0;
        let hasPreferences = formContainer.find('input[name^="brevo_attributes[PREFERENCES]"]:checked').length > 0;

        if ( (interestsExist && !hasInterests) || (preferencesExist && !hasPreferences) ) {
            validationEl.text('Please select at least one Interest and at least one Preference.');
            return;
        }

        // Get attributes from the unsubscribe modal
		formContainer.find('input[name^="brevo_attributes"]:checked').each(function() {
			const name = $(this).attr('name');
			const value = $(this).val();
			const attributeName = name.substring(name.indexOf('[') + 1, name.indexOf(']'));

			if (!attributes[attributeName]) {
				attributes[attributeName] = [];
			}
			attributes[attributeName].push(value);
		});

        $.ajax({
            url: KGLASS_MODAL.ajax_url,
            type: 'POST',
            data: {
                action: 'klg_update_user_preferences', // Reuse the subscribe action to update user
                nonce: KGLASS_MODAL.nonce,
                email: email,
				attributes: attributes
            },
            success: function(response) {
                if(response.success) {
                    if (activeModal) {
                        activeModal.close();
                    }
                    new jBox('Notice', {
                        content: 'Your preferences have been updated successfully!',
                        color: 'green',
                        autoClose: 5000
                    });
                } else {
                    validationEl.text(response.data.message);
                }
            },
            error: function() {
                validationEl.text('An error occurred. Please try again.');
            }
        });
    });

    // Handle in-page subscribe form "Change Preferences" button click
    $(document).on('click', '#subscribe-in-page-preferences-btn', function(e) {
        e.preventDefault();
        const email = $('#subscriber_email').val();
        const validationEl = $('#in-page-subscribe-form #validation');
        const attributes = {};

        validationEl.css('color', 'red').text('');

        // Basic validation
        if (!email) {
            validationEl.text('Email address is required.');
            return;
        }

        const formContainer = $('#in-page-subscribe-form');
        
        let interestsExist = formContainer.find('input[name^="brevo_attributes[INTERESTS]"]').length > 0;
        let preferencesExist = formContainer.find('input[name^="brevo_attributes[PREFERENCES]"]').length > 0;

        let hasInterests = formContainer.find('input[name^="brevo_attributes[INTERESTS]"]:checked').length > 0;
        let hasPreferences = formContainer.find('input[name^="brevo_attributes[PREFERENCES]"]:checked').length > 0;

        if ( (interestsExist && !hasInterests) || (preferencesExist && !hasPreferences) ) {
            validationEl.text('Please select at least one Interest and at least one Preference.');
            return;
        }

        // Get attributes from the in-page form checkboxes
        formContainer.find('input[name^="brevo_attributes"]:checked').each(function() {
            const name = $(this).attr('name');
            const value = $(this).val();
            const attributeName = name.substring(name.indexOf('[') + 1, name.indexOf(']'));

            if (!attributes[attributeName]) {
                attributes[attributeName] = [];
            }
            attributes[attributeName].push(value);
        });

        $.ajax({
            url: KGLASS_MODAL.ajax_url,
            type: 'POST',
            data: {
                action: 'klg_update_user_preferences',
                nonce: KGLASS_MODAL.nonce,
                email: email,
                attributes: attributes
            },
            success: function(response) {
                if (response.success) {
                    validationEl.css('color', 'green').text(response.data.message || 'Your preferences have been updated.');
                } else {
                    validationEl.css('color', 'red').text(response.data.message);
                }
            },
            error: function() {
                validationEl.css('color', 'red').text('An error occurred. Please try again.');
            }
        });
    });

    // Handle in-page subscribe form "Unsubscribe" button click
    $(document).on('click', '#subscribe-in-page-unsubscribe-btn', function(e) {
        e.preventDefault();
        const email = $('#subscriber_email').val();
        const validationEl = $('#in-page-subscribe-form #validation');

        validationEl.css('color', 'red').text('');

        if (!email) {
            validationEl.text('Email address is required.');
            return;
        }

        $.ajax({
            url: KGLASS_MODAL.ajax_url,
            type: 'POST',
            data: {
                action: 'klg_unsubscribe_user',
                nonce: KGLASS_MODAL.nonce,
                email: email
            },
            success: function(response) {
                if (response.success) {
                    validationEl.css('color', 'green').text(response.data.message || 'You have been unsubscribed.');
                    $('#subscriber_first_name').val('');
                    $('#subscriber_last_name').val('');
                    $('#subscriber_email').val('');
                    $('#in-page-subscribe-form').find('input[type="checkbox"]').prop('checked', false);
                } else {
                    validationEl.css('color', 'red').text(response.data.message);
                }
            },
            error: function() {
                validationEl.css('color', 'red').text('An error occurred. Please try again.');
            }
        });
    });

	// Handle unsubscribe link click
	$(document).on('click', '.open-unsubscribe-modal', function(e) {
		e.preventDefault();
		if ($('#unsubscribe-page-modal').length) {
            originalModalContent = $('#unsubscribe-page-modal').clone();
			activeModal = new jBox('Modal', {
				content: $('#unsubscribe-page-modal'),
				height: 'auto',
                width: '500',
                addClass: 'mailing-list-modal',
                onClose: function() {
                    activeModal = null;
                    $('#unsubscribe-page-modal').replaceWith(originalModalContent);
                }
			}).open();
		}
    });

    // Handle generic close button click
    $(document).on('click', '.close-modal', function(e) {
        e.preventDefault();
        if (activeModal) {
            dismissedByButton = true;
            activeModal.close();
        }
    });
});